import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { injectIntl } from 'react-intl';

import { PortalConfigContext } from '../../../../../../config/portal';
import Slider from '../../../../../../components/Slider';
import { DEBOUNCE_TIMEOUT_LONG } from '../../../../../../constants';

import './styles.css';
import {getBoatConstantsFromI18n} from '../../../../../../tppServices/translations/constants';
import { getMessages } from '../../../../../../tppServices/translations/messages';
class FilterHorsePower extends PureComponent {

  state = {
    min: this.props.min || '',
    max: this.props.max || '',
    symbolMinClass: '',
    symbolMaxClass: '',
    dragging: false
  }

  updateMultiInput() {
    if (this.state.editing || !this.state.dragging) {
      this.setState({ max: this.props.max || '' });
    }
    if (this.state.editing || !this.state.dragging) {
      this.setState({ min: this.props.min || '' });
    }
    this.handleSymbolClass();
  }

  componentDidMount() {
    this.updateMultiInput();
  }

  componentDidUpdate() {
    this.updateMultiInput();
  }

  handleSliderMaxValue(val) {
    const boatConstants = getBoatConstantsFromI18n();
    if (val === boatConstants.DEFAULT_NO_MAX_POWER_HP) {
      return boatConstants.SLIDER_MAX_VALUE;
    }
    return val;
  }

  handleSliderDrag(handle,val) {
    if (this.state.editing) {
      return;
    }
    if (handle === 'min') {
      this.setState({min: val.toString(), dragging: true});
    } else {
      this.setState({max: this.handleSliderMaxValue(val.toString()), dragging: true});
    }

  }

  handleSliderDragEnd(handle,val) {
    if (!this.state.dragging) {
      return;
    }
    this.setState({dragging: false});
    if (handle === 'min') {
      if (this.props.tracking) {
        this.debounceTracking({ ['powerhp']: {'min': val }});
      }
      this.props.handleDataChange('powerhp', {min: val.toString(), max: this.state.max});
    } else {
      if (this.props.tracking) {
        const boatConstants = getBoatConstantsFromI18n();
        if (!val || val === boatConstants.DEFAULT_NO_MAX_POWER_HP) {
          this.debounceTrackingRemove('maximum powerhp removed');
        } else {
          this.debounceTracking({ ['powerhp']: {'max': val }});
        }
      }
      this.props.handleDataChange('powerhp', {min: this.state.min, max: this.handleSliderMaxValue(val.toString())});
    }
  }

  handleDataChange(type, value) {
    if (type === 'min') {
      if (this.props.tracking) {
        if (!value) {
          this.debounceTrackingRemove('minimum powerhp removed');
        } else {
          this.debounceTracking({ ['powerhp']: {'min': value }});
        }
      }
      this.props.handleDataChange('powerhp', {min: value, max: this.state.max});
    } else {
      if (this.props.tracking) {
        if (!value) {
          this.debounceTrackingRemove('maximum powerhp removed');
        } else {
          this.debounceTracking({ ['powerhp']: {'max': value }});
        }
      }
      this.props.handleDataChange('powerhp', {min: this.state.min, max: value});
    }
  }

  debounceTracking = debounce((value) => this.props.tracking.facetAdded(value), DEBOUNCE_TIMEOUT_LONG);
  debounceTrackingRemove = debounce((value) => this.props.tracking.facetRemoved(value), DEBOUNCE_TIMEOUT_LONG);

  handleSymbolClass() {
    // TODO: horse power symbol
    return;
  }

  render() {
    let { intl: { formatMessage: t } } = this.props;
    const messages = getMessages();
    const min = parseInt(this.state.min) || 0;
    const boatConstants = getBoatConstantsFromI18n();
    const max = parseInt(this.state.max) || parseInt(boatConstants.DEFAULT_NO_MAX_POWER_HP);
    return (
      <div className="search-filter powerhp">
        <div className="slider-container">
          <Slider
            min={0}
            max={parseInt(boatConstants.DEFAULT_NO_MAX_POWER_HP)}
            initialMin={'0'}
            initialMax={this.props.initialMax || boatConstants.DEFAULT_NO_MAX_POWER_HP.toString()}
            value={[min, max]}
            marks={{0: ' '}}
            step={5}
            onChange={this.handleSliderDrag.bind(this)}
            onAfterChange={this.handleSliderDragEnd.bind(this)}
            handle={this.props.handle || ''}
          />
        </div>
        <div className="search-filter-group">
          <div className={this.state.symbolMinClass}>
            <input
              type="number"
              className="powerhp-min"
              placeholder={t(messages.powerhpMin)}
              value={this.state.min}
              onChange={(value) => this.handleDataChange('min', value.target.value)}
              onFocus={() => this.setState({editing: true})}
              onBlur={() => this.setState({editing: false})}
              title={t(messages.powerhpMin)}
            />
          </div>
          <span>{t(messages.to)}</span>
          <div className={this.state.symbolMaxClass}>
            <input
              type="number"
              className="powerhp-max"
              name="isGoing"
              placeholder={t(messages.powerhpMax)}
              value={this.state.max === boatConstants.SLIDER_MAX_VALUE ? '' : this.state.max}
              onChange={(value) => this.handleDataChange('max', value.target.value)}
              onFocus={() => this.setState({editing: true})}
              onBlur={() => this.setState({editing: false})}
              title={t(messages.powerhpMax)}
            />
          </div>
        </div>
      </div>
    );
  }
}

FilterHorsePower.propTypes = {
  handle: PropTypes.string,
  handleDataChange: PropTypes.func.isRequired,
  initialMax: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  min: PropTypes.string,
  max: PropTypes.string,
  tracking: PropTypes.shape({
    facetAdded: PropTypes.func.isRequired,
    facetRemoved: PropTypes.func.isRequired,
  }),
};

FilterHorsePower.contextType = PortalConfigContext;

export default injectIntl(FilterHorsePower);
